import { render, staticRenderFns } from "./TicketFilterChips.vue?vue&type=template&id=49342648&"
import script from "./TicketFilterChips.vue?vue&type=script&lang=js&"
export * from "./TicketFilterChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports